export function appendSlashToUrl(url = '') {
  return url?.startsWith('/') ? url : `/${url}`;
}
